export default {
  register: "Register",
  welcome: "Welcome",
  textWelcome: "Welcome",
  textGoodMorning: "Good morning",
  textGoodAfternoon: "Good afternoon",
  textGoodEvening: "Good evening",
  textGoodNight: "Good night",
  loginFail: "Login failed",
  phone: "Phone Number",
  email: "Email",
  agreeTermAndCondition: "Agree terms & conditions",
  pleaseAgreeTermAndCondition: "Please accept the Privacy Policy",
  back: "Back",
  termAndCondition: "Terms and Conditions",
  termAndCondition2: "Terms and Conditions",
  cancel: "Cancel",
  confirm: "Confirm",
  confirmDefault: "Confirm",
  confirmRegistration: "Confirm Registration",
  addItem: "Add Item",
  required: "Please fill in this field",
  zipcode: "Zip code",
  sub_district: "Sub-district",
  district: "District",
  province: "Province",
  save: "Save",
  saveDraft: "Save Draft",
  close: "Close",
  name: "Name",
  surname: "Surname",
  birthDay: "Birthdate",
  gender: "Gender",
  educationLevel: "Education level",
  jobLevel: "Job level",
  jobPosition: "Job position",
  department: "Department",
  company: "Company",
  address: "Address",
  enterRegister: "Register",
  management: "Management",
  manager: "Manager",
  supervisor: "Supervisor",
  officer: "Officer/Staff",
  worker: "Worker/Operator",
  doctorate: "Doctorate",
  masterDegree: "Master's degree",
  bachelorDegree: "Bachelor's degree",
  highVocational: "Higher vocational certificate",
  technicalVocational: "Technical vocational certificate",
  vocational: "Vocational certificate",
  highSchool: "High school",
  secondarySchool: "Secondary school",
  primarySchool: "Primary school",
  lowerPrimary: "Lower than primary school",
  male: "Male",
  female: "Female",
  other: "Other",
  profile: "Profile",
  id: "ID",
  nameSurname: "Name-Surname",
  sendRefCodeOtp: "Ref Code",
  requestOtpAgain: "Request OTP Again",
  edit: "Edit",
  add: "Add",
  addressSendReward: "Delivery Address",
  addressDetail: "Address Details",
  selectDefautAddress: "Default Address",
  addressEdit: "Edit Address",
  addressAdd: "Add",
  defaultValue: "Default Value",
  hello: "Hello K.",
  coinTotal: "Total Points",
  homePage: "Home",
  activityPage: "Activities",
  redemptPage: "Redeem Rewards",
  invitePage: "Invite Friends",
  connectPlatformPage: "Connect Platform",
  connectPlatformPageHint: "E-Commerce To receive special privileges.",
  birthDayPage: "Birthday Gift",
  addressPage: "Delivery Address",
  favoritePage: "Favorites",
  cancelShipment: "Cancel Shipment",
  couponPage: "My Coupons",
  myLuckyDrawPage: "My Lucky Draw",
  myMemberPage: "My Member",
  registerMemberPage: "Register Member",
  statusDeliveryPage: "Check Reward Status",
  transferPage: "Transfer Points",
  logout: "Logout",
  textCategory: "Category",
  categoryAll: "All",
  categoryRecommend: "Recommend",
  categoryFood: "Food",
  categoryElectrical: "Electronic",
  categoryAppliance: "Appliance",
  categoryOther: "Other",
  totalValue: "Remaining Quantity",
  detail: "Details",
  seeMoreDetail: "View Details",
  youWant: "Are you want ",
  delete: "Delete",
  favoriteText: "in your favorite",
  waitingLoad: "Please Wait",
  expireTime: "Expired",
  coin: "Points",
  surveyRegister: "Registration form",
  later: "Later",
  redeem: "redeem",
  redeemPoint: "Redeem used",
  confirmRedeem: "Are you sure to redeem use",
  confirmAdd: "Are you would like to add",
  inYourFav: "to your favorites",
  confirmDelete: "Are you sure to delete",
  fromYourFav: "from your favorites",
  balance: "Balance",
  inviteFrindDetail:
    "Simply invite your friends to use the app. When your friend successfully registers,",
  received: "received",
  inviteFriend: "Invite Friends",
  inviteFriendPhoneText: "Enter the phone number you want to invite",
  inviteFriendLineText: "Invite friends via LINE",
  fillPhone: "Enter Friend's Phone Number",
  historyRedeem: "Redemption History",
  historyCode: "Code History",
  resendCode: "Resend Code",
  coinAll: "Overall",
  coinReceived: "Points Received",
  coinUsed: "Points Used",
  activityAll: "All Activities",
  expireDate: "Expiration Date",
  note: "Note",
  enterNote: "Enter note...",
  checkIn: "Check-in",
  activityExpireDate: "Activity Expiration Date",
  collectCoin: "Collect Points",
  valueItem: "Amount",
  missionReward: "Reward",
  activityJoin: "Join Activity",
  activityQr: "Scan QR Code",
  activitySurvey: "Take Survey",
  activityUpload: "Upload Activity Results",
  activityScanQr: "SCAN QR",
  scanCode: "Scan Code",
  sendSurvey: "Send Survey",
  uploadFile: "Upload File",
  sizeFile: "File size should not exceed 10 MB",
  activityStatusJoin: "Joined Activities",
  activityStatusWait: "Pending Activities",
  activityStatusSuccess: "Successful Activities",
  activityStatusReject: "Failed Activities",
  activityStatusAll: "Activities All",
  registerToReceive: "Register",
  confirmUseCoupon: "Confirm to use the coupon",
  noteUseCoupon:
    "We recommend that you use the coupon when you are at the store to prevent losing your rights.",
  noteAlertUseCoupon:
    "The code will be considered used immediately after you click claim.",
  codeDiscount: "Discount Code",
  errorQr: "Show this if the rendering fails.",
  cancelRedemption: "Do you want to cancel the transaction?",
  cancelRedemptionNote:
    "You will not receive point if you cancel the transaction.",
  statusDelivery: "Reward Delivery Status",
  statusSendIn7Day: "Delivered within 7 days",
  shippingInProcess: "Processing",
  statusDeliverySuccess: "Delivered successfully",
  statusDeliveryCancel: "Cancel delivery",
  trackingNumber: "Tracking number",
  receiveReward: "Receive reward",
  copyText: "Copied",
  confirmReceiveReward: "Confirm to receive reward",
  activitySuggest: "Recommended Activities",
  pageNotFound: "Not Found Page",
  goBackPage: "Go to Back Page",
  goToLogin: "Go To Login Page",
  changeLanguage: "Language",
  all: "all",
  join: "join",
  joined: "joined",
  success: "success",
  failed: "failed",
  waiting: "waiting",
  pending: "Pending",
  sent: "Sent",
  delivered: "Delivered",
  textRequireOTPAgain: "Request a new OTP code again within : ",
  welcomeActivity: "Welcome to join activity",
  errQr: "Invalid QR Code, please try again.",
  requireExam: "Please complete the questionnaire.",
  uploadSuccess: "The result has been sent.",
  uploadWaiting: "An inspection will be conducted within 7 days.",
  errDupActivity:
    "You have completed this task. Please select another activity.",
  errExpireActivity: "Sorry, the activity has expired.",
  errActivity: "Sorry, you are not eligible for this activity.",
  errFileUpload: "File size should not exceed 10 MB.",
  errMyLuckyDrawNotEnough: "Sorry, you don't have enough entries remaining.",
  expireDateUse: "expire date",
  registerPage: "Registration page",
  shareActivity: "Share Activity",
  goToMission: "Go to Activity",
  menuActivity: "Activity",
  menuRedeem: "Redeem Rewards",
  menuCoupon: "My Coupons",
  privacyPolicy: "Privacy Policy",
  favoriteCategory: "Favorite",
  deviceCategory: "Electronic Devices",
  accessoryCategory: "Electronic Accessories",
  healthCategory: "Health & Beauty",
  foodCategory: "Food & Beverage",
  babyCategory: "Baby & Toys",
  petCategory: "Pets",
  homeCategory: "Home & Lifestyle",
  menCategory: "Men's Fashion",
  womenCategory: "Women's Fashion",
  sportCategory: "Sports",
  travelCategory: "Travel",
  reward: "Reward",
  missionComing: "Mission Coming",
  startDate: "startDate",
  endDate: "endDate",
  home: "Home",
  activity: "Activity",
  tracking: "Tracking",
  account: "Account",
  historyCoupon: "Coupon History",
  rewardSoHot: "Hot Rewards",
  hotMission: "Hot Activities",
  recommendMission: "Recommended Activities",
  doneDetailMission: "Participation Details",
  detailMission: "Activities Details",
  newActivityUpload: "Resubmit",
  errNotTimeForActivity: "This activity hasn't started yet.",
  news: "News",
  birthDayGift: "Birthday Gift",
  friendRecommend: "Recommended Friends",
  friendRequest: "Friend Requests",
  friendList: "Friend List",
  rewardLimitReached: "Reward limit reached",
  limitReached: "Limit reached",
  limitReachedPerDay: "Daily limit reached",
  textComingSoon: "Coming Soon",
  textTimeCannotJoin: "Outside activity period",
  couponExpired: "Coupon Expired",
  myLuckyDrawExpire: "Expired",
  conditionCoin: "Terms apply",
  rewardPrize: "Prize",
  agree: "Agree",
  disagree: "Disagree",
  activityHeartToHeart: "Send Message",
  rewardComingSoon: "Coming Soon",
  addMember: "Add Member",
  conditionEntryPass: "Entry Requirements",
  letsJoin: "Join Now",
  isUsed: "Redeemed",
  editProfile: "Edit Profile",
  textProfile: "Profile",
  searchMissionOrReward: "Search Activities or Rewards",
  searchHistory: "Search History",
  removeSearchHistory: "Clear Search History",
  messageActivityUpcoming: "Stay tuned! New activity coming soon 🎉",
  messageActivityErrorReJoin:
    "Action failed.\nPlease join directly from the activity page.",
  errActivityAlreadyJoined: "Sorry, you have already joined this activity.",
  errActivityDataNotFound: "Sorry, activity information not found.",
  redeemSuccessWithClaimInstruction:
    "Redemption successful! Please claim your prize in 'My Rewards'.",
  redeemSuccess: "Redemption Successful",
  errRewardOutOfStock: "Sorry, this reward is out of stock.",
  errRedeemFail: "Sorry, redemption failed. Please try again.",
  textSorry: "Sorry,",
  errDataNotFound: "Sorry, data not found.",
  errSubmissionFailed: "Sorry, submission failed. Please try again.",
  errRegistrationFailedContactAdmin:
    "Registration failed. Please contact the administrator.",
  btnRedirectMyCoupon: "Go to My Coupons",
  infoCouponReadyMyCoupons: "You can use your coupons in 'My Coupons'.",
  coinCost: "Points Required",
  next: "Next",
  skip: "Skip",
  otpVerified: "OTP Verified",
  successOTPVerified: "OTP Verified Successfully",
  dataNotFound: "No data found",
  version: "Version",
  viewAll: "View All",
  availableStock: "Items Remaining",
  expiredAt: "Expires in",
  expiredAt2: "Expired at",
  rewardToReceive: "Reward to receive",
  chooseRewardToReceive: "Select your reward",
  viewResultActivity: "View Activity Results",
  titleInvite:
    "{name} invited you to join our loyalty program and earn exclusive rewards.",
  thankYouForParticipatingActivity: "Thank you for participating!",
  doActivityBy: "Action by",
  textNotSpecified: "Not specified",
  textIncognito: "Incognito Mode",
  viewHistory: "View History",
  history: "History",
  locationName: "Location Name",
  location: "Location",
  selectRedeemRewardLocation: "Select collection point",
  selectAddressSendReward: "Select shipping address",
  instructionAddAddressSendReward: "Please add a shipping address.",
  textSelect: "Select",
  instructionEnterRegisteredPhone:
    "If you already have an account, please enter your registered phone number.",
  instructionEnterRegisteredEmail:
    "If you have already registered, please enter your registered email.",
  textFirstRegistration: "First-time Registration",
  textClickHere: "Click here",
  statusRegistrationSuccess: "Registration Successful",
  statusRegistrationFailed: "Registration Failed",
  instructionUploadIDPassport: "Please upload your ID Card or Passport.",
  textUploadIDPassport: "Upload ID Card / Passport",
  rewardStartDate: "Redemption Start Date",
  rewardExpiredDate: "Reward Expiry Date",
  detailMyLuckyDraw: "Entry Details",
  date: "Date",
  errUserNotFound: "Sorry, user not found.",
  textSelectUser: "Select User",
  textSelectFile: "Select File",
  textImageType: "Image",
  textVideoType: "Video",
  instructionSelectOrAddAddress: "Please select or add a shipping address.",
  instructionSelectRewardMission: "Please select {amount} reward(s).",
  textTopRanking: "Top Ranking",
  textRank: "Rank",
  textTotalAmount: "Total Amount",
  viewProfile: "View Profile",
  addFriend: "Add Friend",
  cancelFriend: "Unfriend",
  removeFriendSuccess: "Successfully removed from friends",
  instructionUploadImageVideo: "Upload Image/Video (Max {size}MB)",
  textUnsupportedFileType: "Unsupported file type.",
  textAdditionalDescription: "Additional Description",
  textDescription: "Description",
  textLocationOrBranchName: "Location / Branch Name",
  textCheckInTime: "Check-in Time",
  textCheckOutTime: "Check-out Time",
  textLastUpdate: "Last Updated",
  instructionLineReopenExternalBrowser:
    "Please reopen in an external browser to log in.",
  errPhoneIsUsed: "Sorry, this phone number is already in use.",
  textConditionEntryPassGamification: "Entry Requirement",
  textFree: "Free",
  textCongratsReceived: "Congratulations! 🎉 You received",
  happyBirthMonth: "Happy Birthday Month!",
  happyBirthMonthWish:
    "Wishing you a special day filled with joy, smiles, and the gifts you deserve! 🎁 May this year bring you only the best things!",
  confirmDeleteMember: "Are you sure you want to delete member {name}?",
  removeMemberSuccess: "Member removed successfully",
  removeMemberFail: "Failed to remove member",
  confirmEditProfile: "Do you want to save changes to your profile?",
  bonusCoin: "Bonus Points",
  receiveCoin: "You've earned points",
  status: "Status",
  checkSendCodeHistory: "You can use your coupons in 'My Coupons'.",
  errTimeOut: "Sorry, the time has expired.",
  inviteHeadline: "More friends, more fun!",
  inviteFriendNow: "Invite your friends to the app now!",
  copyInviteLink: "Copy Invite Link",
  copyInviteLinkSuccess: "Invite link copied to clipboard",
  detailScanQrCode: "Please align the QR Code in the center.",
  pleaseFill: "Please fill in",
  comment: "Comment",
  claimSpecialGift: "Claim Special Gift",
  claimGift: "Claim Gift",
  claimGiftSuccess: "Gift claimed successfully",
  list: "List",
  summary: "Summary",
  collected: "Collected",
  collectedItemCount: "{count} items collected",
  invalidPhoneNumber: "Please enter a valid phone number",
  duplicateData: "Duplicate data",
  saveSuccess: "Saved successfully",
  uploadSuccessful: "Upload successful",
  memberLevel: "Current Level",
  maxLevelReached: "Congratulations! You've reached the highest level. 🎉",
  // earnMoreForNextLevel:
  //   "Earn {nextLevelEarn} points more to reach {nextLevelName}",
  earnMoreForNextLevel: "Earn {nextLevelEarn} more to reach {nextLevelName}",
  code: "Code",
  codeNo: "Code No. {no}",
  qrCode: "QR Code",
  barCode: "Barcode",
  removeCache: "Clear Cache",
  connect: "Connect",
  luckyDrawCount: "Chances",
  locationAccessDenied:
    "Unable to retrieve your location. Please allow location access.",
  viewing: "Viewing",
  cameraError: {
    notAllowed: "Please grant permission to access the camera",
    notFound: "ERROR: no camera on this device",
    notSupported: "ERROR: secure context required (HTTPS, localhost)",
    notReadable: "ERROR: is the camera already in use?",
    overconstrained: "ERROR: installed cameras are not suitable",
    streamApiNotSupported: "ERROR: Stream API is not supported in this browser",
    insecureContext:
      "ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.",
    unknown: "ERROR: Camera error ({error_name})",
  },
  error: {
    title: "Oops! error",
    general: "Something went wrong. Please try again.",
    unknown: "An unknown error occurred",
    network: "Network error. Please check your connection.",
    timeout: "Request timed out.",
    notFound: "Sorry, the requested information was not found.",
    unauthorized: "You do not have permission to access this.",
    sessionTimeout:
      "Your session has expired. Please log in again to continue.",
    heicNotSupported:
      "HEIC/HEIF files are not supported. Please use JPG or PNG.",
    imageSupported: "Only JPG, JPEG, and PNG files are supported.",
    ocrProductNotFound: "No matching product found from the scanned label.",
  },
  yourCodeIs: "Your code is",
  validation: {
    required: "Required.",
    phoneInvalid: "Phone number is not valid",
    emailInvalid: "Invalid email address",
    enterOTP: "Please enter the OTP",
    otpInvalid: "OTP must be 6 digits",
    uploadLimit: "Maximum of {number} items allowed",
    numberInvalid: "Must be a number",
    minCode: "Please enter at least one code",
    maxFilesAllowed: "You can upload maximum {count} files",
    invalidFileFormat: "Invalid file format. Please upload another file.",
  },
  redeemAmount: "Redemption Amount: {quantity}",
  duration: "Duration",
  webAccessDenied:
    "Access Denied: You do not have permission to access this website",
  webRedirecting: "Redirecting to the correct website...",
  or: "Or",
  notEnough: "Insufficient balance",
  notAvailable: "Not available.",
  amount: "Amount",
  message: "Message",
  loginLineLoading: "Loading Login Line...",
  signinWithLine: "Sign in with Line",
  signinWithGoogle: "Sign in with Google",
  sampleImage: "Sample Image",
  submitResult: "Submit Result",
  submit: "Submit",
  unit: {
    km: "Kilometer",
    cc: "CC",
    unit: "Units",
  },
  menuMain: "Main",
  menuMore: "More",
  menuChatRoom: "Inbox",
  menuInformationCenter: "Info Center",
  menuInformationCenterFull: "Information Center",
  menuCampaign: "Campaign",
  menuRequest: "Request",
  menuWarranty: "Warranty",
  joinedCampaigns: "Joined Campaigns",
  campaignTotalPoint: "Total Point",
  campaignTotalAmount: "Total Amount",
  allRequest: "All Requests",
  newRequest: "New Request",
  textFilter: "Filter",
  textSortBy: "Sort by",
  textUpdated: "updated",
  textAttachmentCount: "{count} Attachments",
  textAttachmentFile: "Attachment Files",
  textFilePreview: "File Preview",
  textReply: "Reply",
  textReplyForm: "Reply Form",
  textForm: "Form",
  textFillInForm: "Fill in form",
  textPost: "Post",
  textInputComment: "Comment",
  textViewMoreComment: "View more comments",
  textViewMoreReply: "View more replies",
  textRewardCount: "× {count} item(s)",
  filterAll: "All",
  filterFavorite: "Favorited",
  filterUnread: "Unread",
  filterNoType: "No Type",
  filterReportStatus: "Status : {report_status_name}",
  sortDate: "Sort by Date",
  sortTitle: "Sort by Title",
  sortExpiredDate: "Sort by Expired Date",
  sortProduct: "Sort by Product",
  sortRegisterDate: "Sort by Register Date",
  clear: "Clear",
  addFavorite: "Add to Favorites",
  removeFavorite: "Remove from Favorites",
  extraBonus: "Extra Bonus",
  deliveryPickup: "Pickup",
  deliveryThailandPost: "Thailand Post",
  pleaseFillDetail: "please input detail here ...",
  textTitle: "Title",
  textSubtitle: "Subtitle",
  textType: "Type",
  textProduct: "Product",
  hintUploadMultiFile:
    "Max {fileLimit} files, maximum total file size is {fileLimitMB} MB.",
  errorUploadLimitFileSize:
    "Total file size exceeds the {fileLimitMB} MB limit.",
  specialReward: "Claim your special reward!",
  totalSummaryPoint: "Total Points",
  transferPoint: "Transfer Points",
  confirmTransferPoint:
    "Are you sure you want to transfer {point} points to {name}?",
  transferSuccess: "Points transferred successfully",
  transferDescription: "Transfer points to another member",
  selectRecipient: "Select recipient",
  selectMember: "Select member",
  enterTransferPoints: "Enter the number of points to transfer",
  transferPointAmount: "Points to transfer",
  transferPointType: "Type of Points to Transfer",
  transferPoints: "Transfer points",
  totalPoint: "Total point",
  myPointAll: "All",
  myPointExpire: "Expiring Soon",
  myPointExchange: "Redeem",
  total: "Total",
  toMember: "To",
  remaining: "Remaining",
  max: "Max",
  allWarranty: "All Warranties",
  warranty: "Warranty",
  warrantyRegistration: "Warranty Registration",
  newProductWarranty: "New Product",
  registerWarrantyDescription: "Register your purchase to activate your warranty.",
  registerNow: "Register Now",
  serviceRequest: "Service Request",
  warrantyStatus: {
    active: "ACTIVE",
    pending: "PENDING",
    rejected: "REJECTED",
    expired: "EXPIRED",
  },
  textUploadProductLabel: "Upload Product Label",
  textAutoFillByAI: "Auto-fill details with AI ✨",
  textBtnSelectPhoto: "Select Photo",
  textViewSamplePhoto: "View sample photo",
  textNumberMore: "+{number} more",
  textHide: "hide",
  microsite: {
    invalidPhoneNumber: "Please enter a valid phone number",
    otpVerified: "Confirm OTP",
    sendRefCodeOtp: "Ref OTP",
    textRequireOTPAgain: "Request a new OTP code again within : ",
    requestOtpAgain: "Request OTP Again",
    confirmDefault: "Confirm",
    enterOTP: "Please enter the OTP",
    otpInvalid: "OTP must be 6 digits",
    textTransactionDetail: "Transaction Detail",
    createdAt: "Date",
    summary_amount: "Summary Amount",
    point: "Point",
    status: "Status",
    status_detail: "Status Detail",
    item_name: "Item Name",
    item_image: "Item Image",
    Approved: "Approved",
    Waiting: "Waiting Approval",
    Rejected: "Rejected",
    Pending: "Pending",
    privacyPolicy: "Privacy<br />policy",
    termAndCondition: "Terms &<br />conditions",
    textNext: "Next",
    acceptConsent: "I accept",
    dataNotFound: "Data Not Found",
    maxFileSizeAllowed: "File Size is less than {size} MB.",
    maxFilesAllowed: "You can upload maximum {count} files",
    errSubmissionFailed: "Sorry, your submission failed.",
    errGeneral: "Something went wrong. Please try again.",
    successOTPVerified: "OTP Verified successfully",
    textBack: "Back",
    errActivityAlreadyJoined: "Sorry, you have already joined this activity.",
    textRefresh: "Refresh",
    errActivity: "Sorry, you cannot join this activity.",
    textRegistrationHistory: "REGISTRATION HISTORY",
    textTotalPoint: "Total point",
    textTotalAmount: "Total amount",
    textHistory: "HISTORY",
    textNo: "No",
    textCode: "Code",
    textSuccess: "Success",
    textNotFound: "Not Found",
    textUsed: "Used",
    errUserNotFound: "Sorry, user not found.",
    loginSuccess: "Login successful.",
    registerSuccess: "Register successful.",
    textResultsSummary: "Results Summary",
    textTopRankingCampaign: "Top {num} Ranking",
    textRank: "Rank",
    textPhone: "Phone Number",
    textTotal: "Total",
    textLuckyDrawClaimed:
      "You have already claimed your Lucky Draw rights for this campaign.",
    textContactAdminToChange:
      "To change your selection, please contact administrator.",
    textConnectWithLine: "Connect with LINE",
    textBackHome: "Home",
  },
};
